import { render } from "./SalesLeads.vue?vue&type=template&id=a0169322&scoped=true&ts=true"
import script from "./SalesLeads.vue?vue&type=script&lang=ts"
export * from "./SalesLeads.vue?vue&type=script&lang=ts"

import "./SalesLeads.vue?vue&type=style&index=0&id=a0169322&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0169322"]])

export default __exports__